export enum ADVISOR_ESTIMATE {
    OPEN_FOR_ESTIMATE = "เปิดให้ประเมิน", // i18n-ignore (data: compared with backend estimate_status)
    NOT_START_YET = 'ยังไม่ถึงช่วงเวลาที่เปิดให้ประเมิน', // i18n-ignore (data: compared with backend estimate_status)
    START_FOR_ESTIMATE = 'เปิดให้ประเมิน', // i18n-ignore (data: compared with backend estimate_status)
    END_FOR_ESTIMATE = 'สิ้นสุดเวลาที่เปิดให้ประเมิน' // i18n-ignore (data: compared with backend estimate_status)
}